import Rest from '@/services/Rest';

/**
 * @typedef {RedirectService}
 */
export default class SubscriptionsReportService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/report/subscriptions';

    /**
     * @returns {*|PromiseLike<T | never>|Promise<T | never>}
     * @param data
     * @param config
     */
    export(data, config = {}) {
        return this.post(`/export`, data, config);
    }

    bigNumber(reportName, filters, config = {}) {
        let parameters = {
            url:`/bignumbers/${reportName}`,
            ...filters
        }
        return this.search(parameters, config);
    }
}
